import { instance } from '@/services/avik-api-gateway'
import { DeviationCancel } from '@/types/deviation-cancel'
import { AxiosResponse } from 'axios'

export function createDeviationCancel(
  body: Partial<DeviationCancel>
): Promise<AxiosResponse<DeviationCancel>> {
  return instance.post(`/deviation-cancel`, body)
}
